import React from 'react';
import { MicAnnounceLine } from 'sushiweb/Icons';
import { red } from 'sushiweb/tokens/color';

import { CopyText } from '../../../UiKit';

export const AlternativeNumbers = ({
  alternativeNumbers,
  escalationNumbers,
  isWFH,
  orderId,
  userId,
  calledTo,
  position = '85%',
}) => {
  if (!alternativeNumbers && !escalationNumbers) return null;

  const numberTempate = (number, isMerchantEscalation = false, role = '') => {
    return (
      <CopyText
        maskEverything={true}
        isMerchantEscalation={isMerchantEscalation}
        title={number}
        isWFH={isWFH}
        masking={true}
        maskingCount={4}
        orderId={orderId}
        userId={userId}
        calledTo={calledTo}
        role={role}
        // position='85%'
      />
    );
  };

  return (
    <div className='alternativeNumbers' data-dd-privacy='mask'>
      {alternativeNumbers && alternativeNumbers.length ? (
        <div className='pb20 pt10'>
          <p className='pb10 bold huge'>Alternate Numbers: </p>
          {alternativeNumbers.map((number, index) => {
            return (
              <div className='pb10' key={index}>
                {numberTempate(number, false)}
              </div>
            );
          })}
        </div>
      ) : null}
      {escalationNumbers && escalationNumbers.contact_details ? (
        <div className='pt10'>
          <p className='pb10 bold huge'>Escalation Numbers: </p>
          {escalationNumbers.warning_text && (
            <p
              className={`pb20 large semiBold ${escalationNumbers.warning_text_color}`}
            >
              <span className='iconMarginR'>
                <MicAnnounceLine size={22} color={red.z500} />
              </span>
              {escalationNumbers.warning_text}
            </p>
          )}
          {escalationNumbers.contact_details &&
            escalationNumbers.contact_details.map((item, index) => {
              return (
                <div className='row flex pb10' key={index}>
                  {item.role && (
                    <p className='bold iconMarginR capitalize'>{item.role}: </p>
                  )}
                  {numberTempate(item.phone_string, true, item.role)}
                </div>
              );
            })}
        </div>
      ) : null}
    </div>
  );
};
